import { useState, useMemo, useRef } from "react";
import { ToolsShell, primaryBtn, TOOLS_ACCENT } from "./ToolsShell.jsx";
import { generateQR } from "./qrcode.js";

export default function QR() {
  const [text, setText] = useState("https://nerdsuite.app");
  const canvasRef = useRef(null);

  const qr = useMemo(() => {
    const t = text.trim();
    if (!t) return { err: "Enter text or a link" };
    try {
      return { ...generateQR(t) };
    } catch (e) {
      return { err: e.message };
    }
  }, [text]);

  const download = () => {
    if (qr.err) return;
    const scale = 12, quiet = 4;
    const dim = (qr.size + quiet * 2) * scale;
    const cv = document.createElement("canvas");
    cv.width = cv.height = dim;
    const ctx = cv.getContext("2d");
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, dim, dim);
    ctx.fillStyle = "#000";
    for (let r = 0; r < qr.size; r++)
      for (let c = 0; c < qr.size; c++)
        if (qr.matrix[r][c]) ctx.fillRect((c + quiet) * scale, (r + quiet) * scale, scale, scale);
    const a = document.createElement("a");
    a.href = cv.toDataURL("image/png");
    a.download = "nerdtools-qr.png";
    a.click();
  };

  const cell = 8, quiet = 4;
  const dim = qr.err ? 0 : (qr.size + quiet * 2) * cell;

  return (
    <ToolsShell title="QR Code">
      <label style={{ fontSize: 13, color: "#9A9DBE", display: "block", marginBottom: 6 }}>Text or link</label>
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={3}
        style={{ width: "100%", background: "#13141F", border: "1px solid #262839", borderRadius: 10, color: "#E8E9F3", fontSize: 15, padding: "12px 14px", boxSizing: "border-box", resize: "vertical" }}
      />
      <div style={{ display: "flex", justifyContent: "center", marginTop: 22 }}>
        {qr.err ? (
          <div style={{ color: "#F8716A", fontSize: 14 }}>{qr.err}</div>
        ) : (
          <div style={{ background: "#fff", padding: 16, borderRadius: 12 }}>
            <svg width={dim} height={dim} viewBox={`0 0 ${dim} ${dim}`} shapeRendering="crispEdges">
              {qr.matrix.flatMap((row, r) =>
                row.map((on, c) =>
                  on ? <rect key={`${r}-${c}`} x={(c + quiet) * cell} y={(r + quiet) * cell} width={cell} height={cell} fill="#000" /> : null
                )
              )}
            </svg>
          </div>
        )}
      </div>
      {!qr.err && (
        <div style={{ textAlign: "center", marginTop: 18 }}>
          <div style={{ fontSize: 12, color: "#5B5E7A", marginBottom: 12 }}>QR version {qr.version} · error-correction level M</div>
          <button onClick={download} style={{ ...primaryBtn, width: "100%" }}>Download PNG</button>
        </div>
      )}
    </ToolsShell>
  );
}

